import React from 'react';
import {Col, Row, Tabs} from 'antd';
import {FileTextOutlined} from "@ant-design/icons";

import PageTitle from '../../../components/page/PageTitle';
import ErrorBoundary from '../../../components/ErrorBoundary';
import InvoiceGenerationCard from "../../../components/invoicing/InvoiceGenerationCard";

const Invoicing = () => {

    const tabsItems = [
        {
            label: 'Generate Invoices',
            key: 1,
            children:
                <ErrorBoundary>
                    <Row>
                        <Col span={16}>
                            <InvoiceGenerationCard singleAccount={false} />
                        </Col>
                    </Row>
                </ErrorBoundary>
        }
    ];

    return (
        <>
            <PageTitle title="Invoicing" icon={<FileTextOutlined/>}/>
            <Tabs defaultActiveKey="1" items={tabsItems} />
        </>
    );
};

export default Invoicing;
